import { useState, useRef, useEffect } from "react";
import { Button } from "../ui/button";

// Add Instagram embed styles
const InstagramEmbedStyles = () => (
  <style>{`
    .instagram-media {
      background:#FFF; 
      border:0; 
      border-radius:3px; 
      box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); 
      margin: 1px; 
      max-width:540px; 
      min-width:326px; 
      padding:0; 
      width:99.375%; 
      width:-webkit-calc(100% - 2px); 
      width:calc(100% - 2px);
    }
  `}</style>
);

type Creator = {
  id: number;
  name: string;
  category: string;
  videoUrl: string;
  creatorImgUrl: string;
  creatorName: string;
  creatorRating?: number;
};

  export const creators: Creator[] = [
    {
      id: 1,
      name: "Lifestyle Creator",
      category: "Lifestyle",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/dsouza_noella.mp4",
      creatorImgUrl: "/images/zomato.png",
      creatorName: "Noella Dsouza",
      creatorRating: 5,
    },
    {
      id: 2,
      name: "Lifestyle Creator",
      category: "Lifestyle",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/dhritigour_.mp4",
      creatorImgUrl: "",
      creatorName: "Dhriti Gour",
      creatorRating: 5,
    },
    {
      id: 3,
      name: "Lifestyle Creator",
      category: "Lifestyle",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/thehappynaari.mp4",
      creatorImgUrl: "",
      creatorName: "Khushi Das",
      creatorRating: 4.9,
    },
    {
      id: 4,
      name: "Beauty Influencer",
      category: "Beauty",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/stealthy_skin.mp4",
      creatorImgUrl: "",
      creatorName: "Sneha",
      creatorRating: 4.8,
    },
    {
      id: 5,
      name: "Beauty Influencer",
      category: "Beauty",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/ayushi__bandral.mp4",
      creatorImgUrl: "",
      creatorName: "Ayushi Bandral",
      creatorRating: 4.8,
    },
    {
      id: 6,
      name: "Beauty Influencer",
      category: "Beauty",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/itzshanuuu.mp4",
      creatorImgUrl: "",
      creatorName: "Shanu",
      creatorRating: 4.7,
    },
    {
      id: 7,
      name: "Beauty Influencer",
      category: "Beauty",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/sparkle.with.sakshi.mp4",
      creatorImgUrl: "",
      creatorName: "Sakshi Vishwakarma",
      creatorRating: 4.9,
    },
    {
      id: 8,
      name: "Lifestyle Creator",
      category: "Lifestyle",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/voguish.gal.mp4",
      creatorImgUrl: "",
      creatorName: "Ankita",
      creatorRating: 4.8,
    },
    {
      id: 9,
      name: "Lifestyle Creator",
      category: "Lifestyle",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/swati.kishor.e.mp4",
      creatorImgUrl: "",
      creatorName: "Swati Kishore",
      creatorRating: 4.9,
    },
    {
      id: 10,
      name: "Lifestyle Creator",
      category: "Lifestyle",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/iam_lovely.tiwari.mp4",
      creatorImgUrl: "",
      creatorName: "Shalini Tiwari",
      creatorRating: 5,
    },
    {
      id: 11,
      name: "Fashion Creator",
      category: "Fashion",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/stylewithrupanshu.mp4",
      creatorImgUrl: "",
      creatorName: "Rupanshu Agrahari",
      creatorRating: 5,
    },
    {
      id: 12,
      name: "Fashion Creator",
      category: "Fashion",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/sanchitmadan_.mp4",
      creatorImgUrl: "",
      creatorName: "Sanchit Madan",
      creatorRating: 4.9,
    },
    {
      id: 13,
      name: "Fashion Creator",
      category: "Fashion",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/nimish_lamba_.mp4",
      creatorImgUrl: "",
      creatorName: "Nimish Lamba",
      creatorRating:5,
    },
    {
      id: 14,
      name: "Fashion Creator",
      category: "Fashion",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/kussh_25.mp4",
      creatorImgUrl: "",
      creatorName: "Kush",
      creatorRating: 5,
    },
    {
      id: 15,
      name: "Food Blogger",
      category: "Food",
      videoUrl: "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/therealheenamemon.mp4",
      creatorImgUrl: "",
      creatorName: "Heena Memon",
      creatorRating: 4.8,
    },
    {
      id: 16,
      name: "Food Blogger",
      category: "Food",
      videoUrl:
        "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/margaret.dasgupta.mp4",
        creatorImgUrl: "",
        creatorName: "Margaret Dasgupta",
        creatorRating: 4.8,
    },
    {
      id: 17,
      name: "Food Blogger",
      category: "Food",
      videoUrl:
        "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/foods_onspree.mp4",
      creatorImgUrl: "",
      creatorName: "Esha Gupta Roy",
      creatorRating: 4.9,
    },
    {
      id: 18,
      name: "Food Blogger",
      category: "Food",
      videoUrl:
        "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/glam_foodie__.mp4",
      creatorImgUrl: "",
      creatorName: "Swati Kishore",
      creatorRating: 5,
    },
   

    {
      id: 19,
      name: "Beauty Influencer",
      category: "Beauty",
      videoUrl:
        "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/thesmokeyeyesgirl.mp4",
      creatorImgUrl: "",
      creatorName: "Anjali Rana",
      creatorRating: 5,
    },
    {
      id: 20,
      name: "Beauty Influencer",
      category: "Beauty",
      videoUrl:
        "https://fkm-1ffdb.kxcdn.com/rnapp/woost/woost-web/videos/anannyaraii.mp4",
      creatorImgUrl: "",
      creatorName: "Khushboo Verma",
      creatorRating: 5,
    },
  ];

type CreatorCardProps = {
  creator: Creator;
  isPlaying: boolean;
  onPlay: () => void;
  videoRef: (el: HTMLVideoElement | null) => void;
};

const getInitialVisibleCount = () => {
  if (typeof window !== "undefined") {
    return window.innerWidth < 640 ? 6 : 5; // 6 for mobile, 5 for desktop/tablet
  }
  return 5;
};


export const CreatorCard = ({ creator, isPlaying, onPlay, videoRef }: CreatorCardProps) => {
  return (
    <div className="relative p-2 bg-white rounded-xl overflow-hidden shadow-sm group transition-all duration-300 hover:shadow-md">
      <div className="aspect-[9/16] w-full bg-gray-200 rounded-xl relative overflow-hidden">
        <video
          ref={videoRef}
          src={creator.videoUrl}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
          playsInline
          loop
          preload="metadata"
        />
        <div
          className={`absolute inset-0 flex items-center justify-center z-20 ${
            isPlaying ? "bg-transparent" : "bg-black bg-opacity-20"
          }`}
          onClick={onPlay}
        >
          <div
            className={`w-14 h-14 md:w-16 md:h-16 bg-woost-blue rounded-full flex items-center justify-center transform transition-all duration-300 ${
              isPlaying ? "opacity-0" : "opacity-100"
            }`}
          >
            <svg
              className="w-7 h-7 md:w-8 md:h-8 text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              {isPlaying ? (
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
              ) : (
                <path d="M8 5v14l11-7z" />
              )}
            </svg>
          </div>
        </div>
        <div className="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded-full z-20">
          {creator.category}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 z-20">
          <div className="text-white">
            <h3 className="font-semibold text-sm md:text-base">{creator.name}</h3>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between p-2 pt-4 bg-white rounded-b-xl">
       <div className="flex items-center gap-2">
        {/* <img src={creator.creatorImgUrl} alt={creator.creatorName} className="h-10 w-10 rounded-full"/> */}
        <span className="text-sm font-medium text-black">{creator.creatorName}</span>
       </div>
       <div>
        <span className="text-sm text-gray-500 ml-2">
          {creator.creatorRating ? `${creator.creatorRating} ⭐` : ""}
        </span>
       </div>
      </div>
    </div>
  );
};

const CreatorGallery = () => {
  const categories = [
    "All",
    "Fashion",
    "Beauty",
    "Food",
    "Lifestyle",
  ];
  const [activeCategory, setActiveCategory] = useState("All");
  const [playingId, setPlayingId] = useState<number | null>(null);
  const videoRefs = useRef<{ [key: number]: HTMLVideoElement | null }>({});
  const [visibleCount, setVisibleCount] = useState(getInitialVisibleCount());


  const filteredCreators =
    activeCategory === "All"
      ? creators
      : creators.filter((creator) => creator.category === activeCategory);


      useEffect(() => {
        const handleResize = () => {
          setVisibleCount(getInitialVisibleCount());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
      useEffect(() => {
        setVisibleCount(getInitialVisibleCount());
      }, [activeCategory]);

  const handlePlay = (id: number) => {
    // Pause all videos
    Object.values(videoRefs.current).forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
    // Play selected video
    const selectedVideo = videoRefs.current[id];
    if (selectedVideo) {
      selectedVideo.play();
    }
    setPlayingId(id);
  };

  const statistics = [
    { value: "2.8x", label: "Average ROAS" },
    { value: "40%", label: "Higher Engagement" },
    { value: "3x", label: "Faster Content Creation" },
    { value: "25K+", label: "Creators Network" },
  ];

  return (
    <section id="creators" className="py-20 bg-gray-50">
      <InstagramEmbedStyles />
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Connect with 10,000+ Creators
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover authentic creators across multiple niches for your next
            campaign
          </p>
        </div>

        <div className="flex justify-start md:justify-center mb-8 overflow-x-auto hide-scrollbar -mx-4 px-4 md:px-0">
          <div className="flex space-x-2 md:space-x-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                  activeCategory === category
                    ? "bg-woost-blue text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-6">
          {filteredCreators.slice(0, visibleCount).map((creator) => (
            <CreatorCard
              key={creator.id}
              creator={creator}
              isPlaying={playingId === creator.id}
              onPlay={() => handlePlay(creator.id)}
              videoRef={(el) => (videoRefs.current[creator.id] = el)}
            />
          ))}
        </div>

        {visibleCount < filteredCreators.length && (
          <div className="flex justify-center mt-8">
            <Button
              onClick={() => setVisibleCount((prev) => prev + 5)}
              className=" bg-woost-blue text-white font-semibold shadow hover:bg-woost-blue-dark transition"
            >
              Load More
            </Button>
          </div>
        )}

        <div className="mt-16 bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-woost-soft-blue/30 via-white to-woost-soft-yellow/30"></div>

          <div className="relative z-10">
            <div className="text-center mb-12">
              <h3 className="text-2xl md:text-3xl font-bold">
                From awareness to conversions
              </h3>
              <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto md:text-xl">
                Woost helps your brand grow with nano & micro influencers who
                deliver results
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {statistics.map(({ value, label }) => (
                <div key={label} className="text-center p-4">
                  <div className="text-3xl md:text-4xl font-bold text-woost-blue mb-2">
                    {value}
                  </div>
                  <div className="text-sm text-gray-600">{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorGallery;
